import { withStaticSponsors } from '../../data/staticSponsors'

export const sponsorTypesInitialState = {
  types: withStaticSponsors(null),
  isLoading: true,
}
